import { getConfig } from "./featureSwitch";
const configs = {
    vbp: 'off',
    bkw: 'off',
    twente: 'off',
    aanzet: 'on',
    dnb: 'off',
    flevo: 'off',
    rdam: 'off'
};
export const loanRulesNotice = getConfig(configs);
